import axios from 'axios';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useAppSelector } from '@app/store/hooks';
import { endpoints } from '@app/api/apis';
import { updateForeclosureDetails } from '@app/store/slices/authSlice';

const useFetchForeclosureDetails = () => {
  const dispatch = useDispatch();
  const userDetails = useAppSelector((state) => state.auth.userDetails);
  const [foreClosureData, setForeClosureData] = useState<any>(null);
  const [fetchForeclosureDetailsLoading, setFetchForeclosureDetailsLoading] = useState(true);
  const fetchForeclosureDetails = async () => {
    setFetchForeclosureDetailsLoading(true);
    try {
      const creditId = userDetails?.linkedCredits[0]?.creditId;
      const url = endpoints.getForeclosureDetails + creditId;
      const res = await axios.get(url);
      setForeClosureData(res?.data ?? {});
      dispatch(updateForeclosureDetails(res?.data ?? {}));
    } catch (err) {
      console.log('fetchClosureRequest', err);
    } finally {
      setFetchForeclosureDetailsLoading(false);
    }
  };

  useEffect(() => {
    fetchForeclosureDetails();
  }, []);

  return {fetchForeclosureDetailsLoading, foreClosureData };
};

export default useFetchForeclosureDetails;  
